import React from 'react';
import { twMerge } from 'tailwind-merge';

import Typography from '@/components/typography';

type Props = {
  className?: string;
};

const BetaBadge: React.FC<Props> = ({ className = undefined }) => {
  return (
    <div
      className={twMerge(
        'justfiy-center items-center bg-green-50 px-1 opacity-100',
        className
      )}
    >
      <Typography className="text-white" variant="body3">
        Beta
      </Typography>
    </div>
  );
};

export default BetaBadge;
